const BASE_URL = 'https://api.dev.auxo.dk';

/**
 * Henter alle elementer fra en specifik CMS-kollektion.
 * @param {string} collectionName - Navnet på kollektionen (f.eks. 'ydelser', 'galleri', 'anmeldelser')
 * @returns {Promise<Array>} En liste af elementer
 */
export async function fetchCollection(collectionName) {
  try {
    const response = await fetch(`${BASE_URL}/public/content/${collectionName}`);
    if (!response.ok) {
      throw new Error(`Kunne ikke hente kollektion: ${collectionName}`);
    }
    return await response.json();
  } catch (error) {
    console.error(`Fejl ved hentning af ${collectionName}:`, error);
    return [];
  }
}

/**
 * Henter et enkelt element baseret på dets sprog og slug.
 * @param {string} lang - Sprogkode (f.eks. 'da')
 * @param {string} slug - Elementets slug
 * @returns {Promise<Object|null>} Elementet eller null hvis ikke fundet
 */
export async function fetchBySlug(lang, slug) {
  try {
    const response = await fetch(`${BASE_URL}/public/by-slug/${lang}/${slug}`);
    if (!response.ok) {
      throw new Error(`Kunne ikke hente element med slug: ${slug}`);
    }
    return await response.json();
  } catch (error) {
    console.error(`Fejl ved hentning af slug ${slug}:`, error);
    return null;
  }
}
